module.exports = __webpack_public_path__ + "static/media/logo_negawatt.668a9ded.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_negawatt.jpg
// module id = 1843
// module chunks = 0